// extracted by mini-css-extract-plugin
export default {"container":"Badge__container___3S0lB","tag":"Badge__tag___3cHKq","numeric":"Badge__numeric___2P37_"};